/**
 * Wordpress dependencies.
 */
import { SVG, Path } from '@wordpress/components';

/**
 * Tabs Vertical logo icon
 */
const TabsVerticalLogo = (
	<SVG
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.8501 5.2998C4.8501 4.60945 5.40974 4.0498 6.1001 4.0498H10.3501V11.3498H6.1001C5.40974 11.3498 4.8501 10.7902 4.8501 10.0998V5.2998ZM10.3501 14.2002H7.1001V18.5002H10.3501V20.0002H6.8501C6.15974 20.0002 5.6001 19.4406 5.6001 18.7502V13.9502C5.6001 13.2598 6.15974 12.7002 6.8501 12.7002H10.3501V14.2002ZM16.1001 
4.1001H22V5.6001H12.1001V4.1001ZM16.1001 7.1001H20V8.6001H12.1001V7.1001ZM16.1001 10.1001H18V11.6001H12.1001V10.1001Z"
		/>
	</SVG>
);

export default TabsVerticalLogo;
